import AppConfigsAPI from '@/api/app-configs'
import DialogAppConfig from '@/components/appConfig/components/DialogAppConfig.vue'

export default {
  name: 'app-config-component',
  components: {DialogAppConfig},
  data() {
    return {
      tableClass: '',
      currentPk: null,
      isModalVisible: false,
      isAddMode: true,
      form: {
        search_key: 'config_name',
        search_value: '',
      },
      selectOptions: {
        list: [
          {value: 'config_name', text: this.$t('config-name')},
          {value: 'config_desc', text: this.$t('config-desc')},
        ],
      },
      tableData: {
        fields: [
          {key: 'detail', label: '', sortable: false, thStyle: {minWidth: '35px', width: '35px'}},
          {key: 'config_name', label: this.$t('config-name'), sortable: true, thStyle: {minWidth: '300px', width: '250px'}},
          {key: 'config_desc', label: this.$t('config-desc'), sortable: true, thStyle: {minWidth: '300px'}},
          {key: 'action', label: this.$t('action'), sortable: false, thStyle: {minWidth: '70px', width: '100px'}},
        ],
        pagination: {
          by: 'create_time',
          limit: 24,
          offset: 0,
          order: 'desc',
          
          search_key: '',
          search_value: '',
          search_mode: 'pagination',
          
          total: 1,
          current: 1,
          perOptions: [
            {value: 12, text: '12'},
            {value: 24, text: '24'},
            {value: 36, text: '36'},
          ],
        },
      },
    }
  },
  methods: {
    search() {
      this.tableData.pagination.current = 1
      this.tableData.pagination.search_key = this.form.search_key
      this.tableData.pagination.search_value = this.form.search_value
      this.form.search_value = ''
      this.$refs.applicationTableBody.refresh()
    },
    handleAdd() {
      this.isModalVisible = true
      this.isAddMode = true;
    },
    openDropDown() {
      this.tableClass = "show-dropdown"
    },
    closeDropDown() {
      this.tableClass = ""
    },
    fetchAppConfigList(ctx) {
      if (ctx.sortBy === "") return
      
      this.tableData.pagination.by = ctx.sortBy
      this.tableData.pagination.limit = ctx.perPage
      this.tableData.pagination.order = ctx.sortDesc ? "desc" : "asc"
      this.tableData.pagination.offset = (this.tableData.pagination.current - 1) * this.tableData.pagination.limit
      
      let params = {
        by: this.tableData.pagination.by,
        limit: this.tableData.pagination.limit,
        offset: this.tableData.pagination.offset,
        order: this.tableData.pagination.order,
        
        search_key: this.tableData.pagination.search_key,
        search_value: this.tableData.pagination.search_value,
        search_mode: "pagination",
      }
      
      return AppConfigsAPI.get('', {params})
          .then(res => {
            const {objects, meta, status} = res.data
            
            if (status !== 200) {
              this.$awn.warning(this.$t('data_get_fail'))
              return []
            }
            this.tableData.list = objects
            
            this.tableData.pagination.total = meta.total_count
            
            return this.tableData.list
          })
    },
    openEditDialog(pk) {
      this.currentPk = pk
      this.isModalVisible = true
      this.isAddMode = false;
    },
    deleteAppConfig(rowData) {
      let params = {
        title: "LinkMeMine",
        context: { path: "delete_checked_app_config_confirm" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: { path: "delete" },
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        if (rowData.flag_default === true) {
          this.$awn.warning(this.$t('default-item-non-deletable'))
          return
        }
        
        AppConfigsAPI.delete(`${rowData.pk}`)
            .then(res => {
              this.$awn.success(this.$t("app_config_info_delete"))
              this.$refs.applicationTableBody.refresh()
            })
      })
    },
    async copyAppConfig(pk) {
      try {
        const res = await AppConfigsAPI.post(`copy/${pk}`)
        if (res.data.objects && res.data.objects.error) {
          throw new Error(res.data.objects.error)
        } else {
          this.$awn.success(this.$t('app_config_info_updated'))
          this.$refs.applicationTableBody.refresh()
        }
      } catch (error) {
        console.error(this.$t('application_add_error'), error)
        this.$awn.warning(error.message)
      }
    },
    closeModal() {
      this.isModalVisible = false
      this.currentPk = null
      this.$refs.applicationTableBody.refresh()
    },
  }
}